import { cardsData } from '@/mocks/homeData';

export default function SectionCards() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            重磅八卦
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            精选每日最劲爆的爆料内容，一网打尽娱乐圈大小八卦
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardsData.map((card) => (
            <article
              key={card.id}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200/50 transition-colors cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded text-xs font-medium bg-accent-500 text-white">
                  {card.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base md:text-lg font-heading font-bold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
                  {card.title}
                </h3>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span>{card.date}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i> {card.views}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}